/* eslint-disable import/extensions */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-use-before-define */
/* eslint-disable no-else-return */
/* eslint-disable prefer-const */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
import Container from "@/common/Layout/Container/Container";
import useAuth from "@/hooks/useAuth";
import useTrans from "@/hooks/useTrans";
import { useLocalContext } from "@/setup/locale-provider";
import { appAlert } from "@/setup/mantine-provider/notifications";
import { getFromStorage, setToStorage } from "@/utils/localStorage";
import {
  Box,
  Button,
  Card,
  Center,
  Checkbox,
  Group,
  Modal,
  PasswordInput,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import dynamic from "next/dynamic";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import OtpForm from "./components/OtpForm";

const ReCAPTCHA = dynamic(() => import("../../common/ReCapcha.js"));

export default function DangKy() {
  const trans = useTrans();
  const { getLabel } = useLocalContext();
  const router = useRouter();
  const { signup, sendOtp, authOtp, token } = useAuth();
  const [opened, setOpened] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState(false);
  const [isReCaptchaNeeded, setIsReCaptchaNeeded] = React.useState(false);

  React.useEffect(() => {
    const hasToken = Boolean(getFromStorage("token"));
    if (hasToken) {
      router.push("/");
    }
  }, []);

  React.useEffect(() => {
    if (!token) return undefined;
    setToStorage("token", token);
    // localStorage.setItem("token", token);
    window.location.href = "/";
    return null;
  }, [token]);

  const resend = async () => {
    try {
      let rs_otpInfo = await sendOtp(form.values.email);
      if (rs_otpInfo.status) {
        return {
          status: true,
          message: `${trans?.register.alert.sendOtpSuccess}${form.values.email}`,
        };
      } else {
        return {
          status: false,
          message: trans?.register.alert.sendOtpFailed,
        };
      }
    } catch (error) {
      console.log(
        "Error handleSubmit => ",
        error.message || error.error || error
      );
      return {
        status: false,
        message: trans?.register.alert.sendOtpFailed,
      };
    }
  };

  const form = useForm({
    initialValues: {
      email: "",
      name: "",
      password: "",
      rePassword: "",
      termsOfService: false,
    },
    validate: {
      email: (value) =>
        /^\S+@\S+$/.test(value) ||
        /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(value)
          ? null
          : trans?.register.validate.email,
      name: (value) =>
        value.length > 0 ? null : trans?.register.validate.blankPassword,
      password: (value) =>
        value.length > 0
          ? /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*#?&]{6,}$/.test(value)
            ? null
            : trans?.register.validate.password
          : trans?.register.validate.blankPassword,
      rePassword: (value, values) =>
        value.length > 0
          ? value !== values.password
            ? trans?.register.validate.password1
            : null
          : trans?.register.validate.blankPassword,
    },
  });

  const handleError = () => {};

  const handleSubmit = async () => {
    if (!form.values.termsOfService) {
      return form.setFieldError("termsOfService", true);
    }

    // true
    try {
      const rs_signup = await signup(form.values);
      if (rs_signup.status) {
        let rs_otpInfo = await sendOtp(form.values.email);
        if (rs_otpInfo.status) {
          setModalTitle(rs_otpInfo.message);
          setOpened(true);
        }
      } else {
        form.setErrors({ email: rs_signup.message });
        // console.log("a", form.values.email);
      }
    } catch (e) {
      form.setErrors({ email: e.message || e.error || e });
      console.log("Error handleSubmit => ", e.message || e.error || e);
    }
  };

  const callback = () => {
    setOpened(false);
    appAlert({
      type: "success",
      message: trans?.register.alert.success,
    });
    router.replace("/dang-nhap");
  };

  return (
    <Box component="div" py={"lg"}>
      <Head>
        <title>{trans?.register.seoTitle}</title>
      </Head>
      <Container size="sm" sx={{ height: "100%" }}>
        <Card shadow="sm" p="lg" radius="md" withBorder>
          <Center>
            <Title order={3}>{trans?.register.title}</Title>
          </Center>
          <form onSubmit={form.onSubmit(handleSubmit, handleError)}>
            <TextInput
              withAsterisk
              label={trans?.register.userName}
              labelProps={{ style: { color: "#000" } }}
              {...form.getInputProps("email")}
              placeholder={trans?.register.placeholder.userName}
              onFocus={() => {
                setIsReCaptchaNeeded(true);
              }}
              mb={5}
            />
            <TextInput
              withAsterisk
              label={trans?.register.fullName}
              labelProps={{ style: { color: "#000" } }}
              {...form.getInputProps("name")}
              placeholder={trans?.register.placeholder.fullName}
              mb={5}
            />
            <PasswordInput
              withAsterisk
              label={trans?.register.password}
              labelProps={{ style: { color: "#000" } }}
              {...form.getInputProps("password")}
              placeholder={trans?.register.placeholder.password}
              mb={5}
            />
            <PasswordInput
              withAsterisk
              label={trans?.register.rePassword}
              labelProps={{ style: { color: "#000" } }}
              {...form.getInputProps("rePassword")}
              placeholder={trans?.register.placeholder.rePassword}
              mb={5}
            />
            <Checkbox
              label={
                <Box
                  sx={{ color: form.errors.termsOfService ? "red" : "#000" }}
                >
                  {trans?.register.role}
                  <Link scroll={false} href={trans?.register.linkPolicy}>
                    <a target={"_blank"} aria-label="Terms of condition">
                      <u>{trans?.register.policy}</u>
                    </a>
                  </Link>
                </Box>
              }
              {...form.getInputProps("termsOfService", { type: "checkbox" })}
              mt={"sm"}
            />

            <Group position="center">
              <Button
                type="submit"
                mt="sm"
                fullWidth
                variant="outline"
                color="dark"
              >
                <Text weight={"500"} transform="uppercase">
                {trans?.register.submit}
                </Text>
              </Button>
            </Group>
            <Center>
              <Box sx={{ display: "flex" }} mt={10}>
                <Text size={"sm"} mr={4}>
                {trans?.register.swap}
                </Text>
                <Link
                  scroll={false}
                  href={"/dang-nhap"}
                  replace
                  // onClick={(e) => {
                  //   e.preventDefault();
                  //   router.replace("/dang-nhap");
                  // }}
                >
                  <a>
                    <Text weight={"700"} transform="uppercase" size={"sm"}>
                    {trans?.register.login}
                    </Text>
                  </a>
                </Link>
              </Box>
            </Center>
          </form>
        </Card>
        <Modal
          opened={opened}
          onClose={() => setOpened(false)}
          title={getLabel(modalTitle)}
        >
          <OtpForm authOtp={authOtp} resend={resend} callback={callback} />
        </Modal>
      </Container>
      {isReCaptchaNeeded && <ReCAPTCHA />}
    </Box>
  );
}
